<div class="movie-detail-section" *ngIf="movie.trReasonsToWatch">
  <div
    class="header-msg title reasons-to-watch-title"
    [attr.data-translate]="'movie.menu.reasonsToWatch'"
    i18n="@@movie.menu.reasonsToWatch"
  >
    Reasons to watch
  </div>
  <div class="text reasons-to-watch-content" [innerHTML]="movie.trReasonsToWatch | safe: 'html'"></div>
</div>
